import React, { useEffect, useState, useContext } from "react";
import { EnvironmentContext } from "../../EnvironmentContext";
import { Toolbar, TextField } from "@mui/material";
import { PaginationComponent } from "../../Components/PaginationComponent";
import { Link } from "react-router-dom";
import APIServices from "../../services/APIServices";
import { useDispatch, useSelector } from "react-redux";
import { setAccessToken } from "../../Redux/Actions";
import { useNavigate } from "react-router-dom";
import moment from "moment";
import "moment-timezone";
import AlertComponent from "../../Components/Alert/Alert";
import "./EventManagement.css";
import apiconfig from "../../config/config";
import { setTotalEventsCount } from "../../Redux/Actions";

const EventManagement = () => {
  const { environment } = useContext(EnvironmentContext)
  const dispatch = useDispatch();
  const navigate = useNavigate()
  const accessToken = useSelector((state) => state.accessToken);
  const [EventsData, setEventsData] = useState([])
  const [isLoading, setIsLoading] = useState(false);
  const [reviewStatuses, setReviewStatuses] = useState({});
  const [eventCounts, setEventCounts] = useState({
    upcoming: 0,
    finished: 0,
    cancelled: 0,
  });
  const [eventStatus, setEventStatus] = useState(false);
  const [errAlert, setErrAlert] = useState(false);
  const [paginationModel, setPaginationModel] = useState({
    page: 0,
    pageSize: 10,
  });
  const [hasNextPage, setHasNextPage] = useState(true);
  const totalEventsCountFromRedux = useSelector((state) => state.totalEventsCount)
  const [searchQuery, setSearchQuery] = useState('');
  const [searchResults, setSearchResults] = useState([]);
  const [noResults, setNoResults] = useState(false);

  moment.tz.add(
    "Asia/Calcutta|HMT BURT IST IST|-5R.k -6u -5u -6u|01232|-18LFR.k 1unn.k HB0 7zX0"
  );
  moment.tz.link("Asia/Calcutta|Asia/Kolkata");

  useEffect(() => {
    if (typeof window !== "undefined") {
      window.scrollTo({ top: 0, behavior: "smooth" });
    }
  }, []);

  useEffect(() => {
    const tokenLocal = JSON.parse(localStorage.getItem("token"));

    if (!accessToken && tokenLocal) {
      dispatch(setAccessToken(tokenLocal));
      APIServices.setAuthToken(tokenLocal);
    } else if (!accessToken && !tokenLocal) {
      navigate("/login");
    }

    if (accessToken || tokenLocal) {
      const tokenToUse = accessToken || tokenLocal;
      APIServices.setAuthToken(tokenToUse);

      const url =
        environment === "Production"
          ? apiconfig.production.apiBaseUrl
          : apiconfig.develpoment.apiBaseUrl;

      APIServices.setApiBaseUrl(url);

      fetchEvents(paginationModel.page, paginationModel.pageSize);
    }
  }, [dispatch, environment, accessToken, navigate, paginationModel]);

  const fetchEvents = (page, limit) => {
    setIsLoading(true);
    APIServices.getAllEvents(page + 1, limit)
      .then((response) => {
        setIsLoading(false);
        setEventsData(response.data.Events);
        dispatch(setTotalEventsCount(response.data.Count))

        const initialReviewStatuses = {};
        response.data.Events.forEach((event) => {
          initialReviewStatuses[event._id] =
            event.admin_approval || "Not Reviewed";
        });
        setReviewStatuses(initialReviewStatuses);

        // Check if there's a next page
        setHasNextPage(response?.data?.Events?.length === limit);
      })
      .catch((err) => {
        setIsLoading(false);
        console.log("Error while fetching all events: ", err);
      });
  };

  const handlePaginationModelChange = (newModel) => setPaginationModel(newModel);

  const handleReviewStatusChange = (event, id) => {
    setIsLoading(true);
    const newStatus = event.target.value;
    setReviewStatuses((prevStatuses) => ({
      ...prevStatuses,
      [id]: newStatus,
    }));

    const eventObject = EventsData.find((event) => event._id === id);

    const body = {
      admin_approval: newStatus,
    };
    APIServices.eventReviewStatus(eventObject._id, body)
      .then((response) => {
        setIsLoading(false);
        setEventStatus(true);
      })
      .catch((err) => {
        setIsLoading(false);
        setErrAlert(true);
        console.log("Error While Changing the Review Event Status: ", err);
      });
  };

  const ReviewStatusDropdown = ({ value, onChange }) => (
    <select className="text-black" value={value} onChange={onChange}>
      <option style={{ color: "#595959" }} value="Reviewed">
        Reviewed
      </option>
      <option style={{ color: "#595959" }} value="Not Reviewed">
        Not Reviewed
      </option>
    </select>
  );

  const columns = [
    {
      field: "eventID",
      headerName: "Event ID",
      width: 150,
      cellClassName: "fullname-cell1",
      headerClassName: "custom-header",
      renderCell: (params) => (
        <Link
          to={`/event-management/event/${params.value}`}
          style={{ color: "blue" }}
        >
          {params.value}
        </Link>
      ),
    },
    {
      field: "trip_post_date",
      headerName: "Trip post date",
      width: 150,
      cellClassName: "fullname-cell1",
      headerClassName: "custom-header",
    },
    {
      field: "trip_start_date",
      headerName: "Trip start date",
      width: 150,
      cellClassName: "fullname-cell1",
      headerClassName: "custom-header",
    },
    {
      field: "trip_status",
      headerName: "Trip status",
      width: 150,
      cellClassName: "fullname-cell1",
      headerClassName: "custom-header",
    },
    {
      field: "trip_organiser",
      headerName: "Trip Organiser",
      width: 200,
      cellClassName: "fullname-cell1",
      headerClassName: "custom-header",
    },
    {
      field: "trip_title",
      headerName: "Trip title",
      width: 300,
      cellClassName: "fullname-cell1",
      headerClassName: "custom-header",
    },
    {
      field: "review_status",
      headerName: "Review status",
      width: 200,
      cellClassName: "fullname-cell",
      headerClassName: "custom-header",
      renderCell: (params) => (
        <ReviewStatusDropdown
          value={reviewStatuses[params.row._id] || params.value}
          onChange={(event) => handleReviewStatusChange(event, params.row._id)}
        />
      ),
    },
  ];

  const getTripStatus = (eventDetails) => {
    const checkIsEventEnd = () => {
      const tripEndDate = eventDetails?.end_date;
      const tripEndTime = eventDetails?.end_time;
      const eventTimeZone = eventDetails?.time_zone;
      let convertedTimeZone = eventTimeZone;

      if (eventTimeZone === "IST") {
        convertedTimeZone = "Asia/Kolkata";
      }
      const eventEndStatus = moment.tz(
        tripEndDate + " " + tripEndTime,
        "YYYY-MM-DD HH:mm",
        convertedTimeZone
      );

      const currentDateAndTime = moment.tz(convertedTimeZone);
      if (eventDetails?.event_status === 'cancelled') {
        return false
      } else {
        return currentDateAndTime.isAfter(eventEndStatus);
      }
    };

    const eventTimeZone = eventDetails?.time_zone;
    let convertedTimeZone = eventTimeZone;

    if (eventTimeZone === "IST") {
      convertedTimeZone = "Asia/Kolkata";
    }
    const isEventStarted = moment.tz(
      eventDetails?.start_date + " " + eventDetails?.start_time,
      "YYYY-MM-DD HH:mm",
      convertedTimeZone
    );

    const currentDate = moment.tz(convertedTimeZone);

    const isTripIsOnGoing = () => {
      if (eventDetails?.event_status === 'cancelled') {
        return false
      } else {
        if (currentDate.isBefore(isEventStarted)) {
          return false;
        } else {
          return true;
        }
      }
    };

    const isCancelledTrip = () => {
      if (eventDetails.event_status === "cancelled") {
        return true
      }
      else {
        return false
      }
    }
    const isEventEnd = checkIsEventEnd();
    const isTripStarted = isTripIsOnGoing();
    const isCancelled = isCancelledTrip()

    if (isEventEnd) {
      return "Finished";
    } else if (isTripStarted) {
      return "Ongoing";
    } else if (isCancelled) {
      return "Cancelled"
    } else {
      return "Upcoming";
    }
  };

  const rows = (searchQuery && searchResults?.length > 0 ? searchResults : EventsData)?.map((item) => ({
    id: item._id,
    _id: item?._id,
    eventID: item?.ID_event,
    trip_post_date: moment(item?.event_created_at).format("DD/MM/YYYY"),
    trip_start_date: moment(item?.start_date).format("DD/MM/YYYY"),
    trip_status: getTripStatus(item),
    // trip_status: item.event_status,
    trip_organiser: item?.organizers,
    trip_title: item?.trip_title,
    review_status: reviewStatuses[item._id] || "Not Reviewed",
    event_object_id: item?._id,
  }));

  const handleSearchChange = (e) => {
    const newQuery = e.target.value;
    setSearchQuery(newQuery);
    setNoResults(false)

    if (newQuery.length === 0) {
      setSearchResults([]);
      return;
    }

    if (newQuery.length >= 4) {
      APIServices.getEventsSeachQuery(newQuery)
        .then((response) => {
          const results = response.data.Events;
          setSearchResults(results);
          console.log('search res:', results)
          setNoResults(results.length === 0);
        })
        .catch((err) => {
          console.log("Error while searching for events:", err);
        });
    }

  }
  useEffect(() => {
    APIServices.getEventsCounts()
      .then((res) => {
        const allCounts = res.data.Counts
        setEventCounts({ upcoming: allCounts.UpcomingEventsCount, finished: allCounts.FinishedEvents, cancelled: allCounts.CancelledEvents })
      })
      .catch((err) => {
        console.log("count err :", err)
      })
  }, [environment])
  const ongoingEvents = totalEventsCountFromRedux - (eventCounts.upcoming + eventCounts.cancelled + eventCounts.finished)

  return (
    <>


      <AlertComponent
        open={eventStatus}
        severity="success"
        onClose={() => setEventStatus(false)}
        text="Event Review updated successfully."
      />

      <AlertComponent
        open={errAlert}
        severity="error"
        onClose={() => setErrAlert(false)}
        text="Something went wrong.Please try again after sometime."
      />


      <div className="event-management-bg-container">
        <div className="travellers-org-container">
          <div className="travellers-org">
            <div className="travells-cont">
              <p className="total-users-para">
                <span className="d-none d-lg-inline">Total</span>  Events
              </p>
              <center>
                <h3 className="total-users-heading">{totalEventsCountFromRedux}</h3>
              </center>

            </div>
          </div>

          <div className="travellers-org">
            <div className="travells-cont">
              <p className="total-users-para"><span className="d-none d-lg-inline">Total</span> Upcoming</p>
              <center>
                <h3 className="total-users-heading">   {eventCounts.upcoming} </h3>
              </center>

            </div>
          </div>

          <div className="travellers-org">
            <div className="travells-cont">
              <p className="total-users-para"><span className="d-none d-lg-inline">Total</span>  Finished</p>
              <center>
                <h3 className="total-users-heading">{eventCounts.finished}</h3>
              </center>

            </div>
          </div>
          <div className="travellers-org">
            <div className="travells-cont">
              <p className="total-users-para"><span className="d-none d-lg-inline">Total</span>  Cancelled</p>
              <center>
                <h3 className="total-users-heading">{eventCounts.cancelled} </h3>
              </center>

            </div>
          </div>
        </div>

        <div>
          <p className="fullname-cell ">Search for events by event id, start date, destination, trip title, start location, organiser</p>
          <TextField size='small'
            type="text"
            placeholder="Search"
            value={searchQuery}
            onChange={handleSearchChange}
            className="input-fields-date"
            inputProps={{
              style: {
                fontSize: 12,
                fontFamily: "Poppins",
              },
            }}
          />
          {noResults && <p className="fullname-cell" style={{ color: "red", marginTop: '5px', fontSize: '13px' }}>No events found</p>}
        </div>
        <main style={{ flexGrow: 1 }}>
          <Toolbar />
          <PaginationComponent
            columns={columns}
            rows={rows}
            isLoading={isLoading}
            paginationModel={paginationModel}
            paginationMeta={{ hasNextPage }}
            onPaginationModelChange={handlePaginationModelChange}
            rowCount={totalEventsCountFromRedux}
          />
        </main>
      </div>
    </>
  );
};

export default EventManagement;
